Pixlee.module('Components.NavbarMobile', function(NavbarMobile, App, Backbone, Marionette, $) {
    var _this = this,
        API;
    NavbarMobile.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var _this = this;

            // Create filter items collection
            this.filterItemsCollection = new Backbone.Collection();

            // Create navbar model with widgetOptions
            this.widgetOptions = options.widgetOptions;
            this.navbarModel = App.reqres.request('get:new:navbar:model', this.widgetOptions);

            // Set photos collection for widget
            this.photos = options.photosCollection;
            this.photoLocations = this.navbarModel.get('location') ? App.request('get:navbar:photo:locations') : {};

            // Set Views
            this.setLayoutViews(this.navbarModel, this.photos, this.photoLocations);
        },
        createInteractiveLightbox: function(lightbox, initialFilters) {
            this.setInteractiveViews(this.navbarModel, this.photos, initialFilters);
            lightbox.show(this.navbarInteractive);
        },
        setLayout: function(navbarModel, photosCollection) {
            var _this = this;
            this.navbarLayout = this.getNavbarMobileLayout(navbarModel, photosCollection);
            this.listenTo(this.navbarLayout, {
                'show': this.showLayoutRegions,
                'create:interactive:lightbox': this.createInteractiveLightbox,
                'update:results:bar:counter': this.updateResultsBarCounter,
                'render:map:markers': this.renderMapMarkers,
                'analytics:track': this.analyticsTrack,
                'check:location:filter': this.checkLocationFilter
            }, this);
            photosCollection.on('sync', function(collection, resp) {
                _this.navbarLayout.triggerMethod('sync');
            });
        },
        setResultsBarView: function(navbarModel) {
            this.filterItemsCollection = new Backbone.Collection();
            this.resultsBarView = this.getResultsBarView(navbarModel, this.filterItemsCollection);
            this.listenTo(this.resultsBarView, {
                'touch:filter:query': this.buildFilterQuery,
                'uncheck:all:items': this.uncheckAllItems,
                'child:uncheck:item': this.uncheckItem,
                'clear:filter:view': this.clearSearchView,
                'reset:map:view': this.resetMapView
            });
        },
        setSearchView: function() {
            this.searchView = this.getSearchView();
            this.listenTo(this.searchView, {
                'add:filter:item': this.addFilterItem,
                'remove:filter:items': this.removeFilterItems,
                'touch:filter:query': this.buildFilterQuery
            }, this);
        },
        setInteractiveView: function(navbarModel, initialFilters) {
            this.navbarInteractive = this.getInteractive(navbarModel, initialFilters);
            this.listenTo(this.navbarInteractive, {
                'show': this.showInteractiveRegions,
                'social:logged:in': this.socialLoggedIn,
                'remove:filter:items': this.removeFilterItems,
                'uncheck:all:items': this.uncheckAllItems,
                'touch:filter:query': this.buildFilterQuery,
                'set:sort:to:default': this.setSortToDefault,
                'update:results:bar:view': this.updateResultsBarView,
                'analytics:track': this.analyticsTrack
            }, this);
        },
        setSeasonsView: function() {
            this.seasonsView = this.getSeasonsView();
            this.listenTo(this.seasonsView, {
                'add:filter:item': this.addFilterItem,
                'remove:filter:items': this.removeFilterItems,
            });
        },
        setCategoriesView: function() {
            var _this = this;
            var selectedView;
            var categoriesSelectOne = this.navbarModel.get('categoriesSelectOne');
            // Resetting these category views because on 'update:display', they don't get overwritten
            this.primaryCategoryView = false;
            this.secondaryCategoryView = false;
            this.tertiaryCategoryView = false;
            this.categoriesFilterCollection = this.widgetOptions.categoryFilters;
            this.filterNames = [];

            _.each(this.categoriesFilterCollection, function(filter) {
                selectedView = _this.getCategoriesHolderView(filter, categoriesSelectOne);
                _this.setCategoryView(selectedView);
                _this.filterNames.push(filter.name);

                if (!_.isFalsy(selectedView)) {
                    _this.listenTo(selectedView, {
                        'add:filter:item': _this.addFilterItem,
                        'remove:filter:items': _this.removeFilterItems,
                        'check:category:filter': _this.checkCategoryFilter
                    });
                    selectedView.listenTo(_this.filterItemsCollection, 'reset', function(collection) {
                        _this.checkCategoryFilter();
                    });
                }
            });
        },
        setPersonalizationView: function(navbarModel) {
            this.personalizationView = this.getPersonalizationView(navbarModel);
            this.listenTo(this.personalizationView, {
                'add:filter:item': this.addFilterItem,
                'remove:filter:items': this.removeFilterItems,
            });
            App.commands.setHandlers({
                'social:login': function(data) {
                    this.triggerMethod('social:login', data);
                }.bind(this.personalizationView),

                'social:login:loaded': function() {
                    this.triggerMethod('social:login:loaded');
                }.bind(this.personalizationView)
            });
        },
        setLocationView: function(navbarModel) {
            this.locationView = this.getLocationView();
            // Location Model Changes
            navbarModel.on('change:map_viewport', this.filterByLocation, this);
        },
        setMapView: function(navbarModel, photosCollection, photoLocations) {
            var _this = this;
            this.mapView = this.getMapView(navbarModel, photosCollection, photoLocations);
            this.listenTo(this.mapView, {
                'add:filter:item': this.addFilterItem,
                'remove:filter:items': this.removeFilterItems,
                'render:map:markers': this.renderMapMarkers,
                'sync:widget': this.syncWidget,
                'analytics:track': this.analyticsTrack
            });
            photosCollection.on('sync', function(collection, resp) {
                _this.mapView.triggerMethod('sync');
            });
        },
        setSortView: function(navbarModel) {
            this.sortView = this.getSortView(navbarModel);
        },
        setLayoutView: function(navbarModel, photosCollection) {
            this.setLayout(navbarModel, photosCollection);
        },
        setLayoutViews: function(navbarModel, photosCollection, photoLocations) {
            // Build navbar from customization options
            if (navbarModel.get('search')) {
                this.setSearchView();
            }
            if (navbarModel.get('location')) {
                this.setLocationView(navbarModel);
                this.setMapView(navbarModel, photosCollection, photoLocations);
            }
            this.setResultsBarView(navbarModel);
            this.setLayoutView(navbarModel, photosCollection);
        },
        setInteractiveViews: function(navbarModel, photosCollection, initialFilters) {
            this.setInteractiveView(navbarModel, initialFilters);
            if (navbarModel.get('categories')) {
                this.setCategoriesView();
            }
            if (navbarModel.get('seasons')) {
                this.setSeasonsView();
            }
            if (navbarModel.get('personalized')) {
                this.setPersonalizationView(navbarModel);
            }
            if (navbarModel.get('sort')) {
                this.setSortView(navbarModel);
            }
        },
        setCategoryView: function(selectedView) {
            if (_.isFalsy(this.primaryCategoryView)) {
                this.primaryCategoryView = selectedView;
            } else if (_.isFalsy(this.secondaryCategoryView)) {
                this.secondaryCategoryView = selectedView;
            } else if (_.isFalsy(this.tertiaryCategoryView)) {
                this.tertiaryCategoryView = selectedView;
            }
        },
        getNavbarMobileLayout: function(navbarModel, photosCollection) {
            return new NavbarMobile.Layout({
                model: navbarModel,
                collection: photosCollection
            });
        },
        getInteractive: function(navbarModel, initialFilters) {
            return new NavbarMobile.Interactive({
                model: navbarModel,
                initialFilters: initialFilters
            });
        },
        getResultsBarView: function(navbarModel, filterItemsCollection) {
            return new NavbarMobile.resultsBar({
                model: navbarModel,
                collection: filterItemsCollection
            });
        },
        getCategoriesHolderView: function(categoriesCollection, categoriesSelectOne) {
            return new NavbarMobile.Categories({
                name: categoriesCollection.name,
                collection: new Backbone.Collection(categoriesCollection.categories),
                categoriesSelectOne: categoriesSelectOne
            });
        },
        getLocationView: function() {
            return new NavbarMobile.Location();
        },
        getMapView: function(navbarModel, photosCollection, photoLocations) {
            return new NavbarMobile.Map({
                model: navbarModel,
                collection: photosCollection,
                photoLocations: photoLocations
            });
        },
        getSeasonsView: function() {
            return new NavbarMobile.Seasons();
        },
        getSearchView: function() {
            return new NavbarMobile.Search();
        },
        getPersonalizationView: function(navbarModel) {
            return new NavbarMobile.Personalization({
                model: navbarModel
            });
        },
        getSortView: function(navbarModel) {
            return new NavbarMobile.Sort({
                model: navbarModel
            });
        },
        getCategoriesRegion: function() {
            var region;
            if (_.isFalsy(this.navbarInteractive.primaryCategoriesRegion.currentView)) {
                region = this.navbarInteractive.primaryCategoriesRegion;
            } else if (_.isFalsy(this.navbarInteractive.secondaryCategoriesRegion.currentView)) {
                region = this.navbarInteractive.secondaryCategoriesRegion;
            } else if (_.isFalsy(this.navbarInteractive.tertiaryCategoriesRegion.currentView)) {
                region = this.navbarInteractive.tertiaryCategoriesRegion;
            }
            return region;
        },
        setCategoryTriggers: function(triggerName, argument) {
            if (!_.isFalsy(this.primaryCategoryView)) {
                this.primaryCategoryView.triggerMethod(triggerName, argument);
            }
            if (!_.isFalsy(this.secondaryCategoryView)) {
                this.secondaryCategoryView.triggerMethod(triggerName, argument);
            }
            if (!_.isFalsy(this.tertiaryCategoryView)) {
                this.tertiaryCategoryView.triggerMethod(triggerName, argument);
            }
        },
        showResultsBarView: function(view) {
            this.show(view, {
                region: this.navbarLayout.resultsBarRegion
            });
        },
        showCategoriesView: function(view) {
            if (!_.isFalsy(view)) {
                var region = this.getCategoriesRegion();
                if (!_.isFalsy(region)) {
                    this.show(view, {
                        region: region
                    });
                }
            }
        },
        showLocationView: function(view) {
            this.show(view, {
                region: this.navbarLayout.locationRegion
            });
        },
        showSeasonsView: function(view) {
            this.show(view, {
                region: this.navbarInteractive.seasonsRegion
            });
        },
        showSearchView: function(view) {
            this.show(view, {
                region: this.navbarLayout.searchRegion
            });
        },
        showPersonalizationView: function(view) {
            this.show(view, {
                region: this.navbarInteractive.personalizationRegion
            });
        },
        showSortView: function(view) {
            this.show(view, {
                region: this.navbarInteractive.sortRegion
            });
        },
        showMapView: function(view) {
            this.show(view, {
                region: this.navbarLayout.mapRegion
            });

        },
        showLayoutRegions: function() {
            this.showResultsBarView(this.resultsBarView);
            if (this.navbarModel.get('search')) {
                this.showSearchView(this.searchView);
            }
            if (this.navbarModel.get('location')) {
                this.showLocationView(this.locationView);
                this.showMapView(this.mapView);
            }
        },
        showInteractiveRegions: function() {
            if (this.navbarModel.get('categories')) {
                this.showCategoriesView(this.primaryCategoryView);
                this.showCategoriesView(this.secondaryCategoryView);
                this.showCategoriesView(this.tertiaryCategoryView);
            }
            if (this.navbarModel.get('seasons')) {
                this.showSeasonsView(this.seasonsView);
            }
            if (this.navbarModel.get('personalized')) {
                this.showPersonalizationView(this.personalizationView);
            }
            if (this.navbarModel.get('sort')) {
                this.showSortView(this.sortView);
            }

            //if there's preset filters (from a direct url with a query param) then set those before anything else
            if (this.navbarModel.hasInitialFilters) {
                this.navbarInteractive.triggerMethod('initialize:preset:filters');
            }

            this.checkCurrentFilters();
        },
        syncWidget: function() {
            this.navbarLayout.triggerMethod('sync');
        },
        clearSearchView: function() {
            this.searchView.triggerMethod('clear:search:view');
        },
        hideLocationRegion: function() {
            this.navbarLayout.triggerMethod('hide:location:region');
        },
        setSortToDefault: function() {
            if (this.navbarModel.get('sort')) {
                this.sortView.triggerMethod('set:sort:to:default');
            }
        },
        checkCurrentFilters: function() {
            if (this.navbarModel.get('categories')) {
                var categoriesModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'category';
                }), 'get', 'id');
                this.setCategoryTriggers('check:items', categoriesModels);
            }
            if (this.navbarModel.get('seasons')) {
                var seasonModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'season';
                }), 'get', 'id');
                this.seasonsView.triggerMethod('check:items', seasonModels);
            }
            if (this.navbarModel.get('personalized')) {
                var personalizationModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'personalization';
                }), 'get', 'id');
                this.personalizationView.triggerMethod('check:items', personalizationModels);
            }
        },
        updateResultsBarView: function() {
            this.resultsBarView.triggerMethod('update:display');
        },
        updateResultsBarCounter: function(photoCount) {
            this.resultsBarView.triggerMethod('update:results:counter', photoCount);
        },
        socialLoggedIn: function(data) {
            this.personalizationView.triggerMethod('social:login', data);
        },
        uncheckAllItems: function() {
            if (this.navbarModel.get('categories')) {
                this.setCategoryTriggers('uncheck:all:items');
            }
            if (this.navbarModel.get('seasons')) {
                this.seasonsView.triggerMethod('uncheck:all:items');
            }
            if (this.navbarModel.get('personalized')) {
                this.personalizationView.triggerMethod('uncheck:all:items');
            }
        },
        uncheckItem: function(childView) {
            var itemId = childView.model.get('id');
            var itemType = childView.model.get('type');
            switch (itemType) {
                case 'category':
                    this.setCategoryTriggers('uncheck:item', itemId);
                    break;
                case 'season':
                    this.seasonsView.triggerMethod('uncheck:item', itemId);
                    break;
                case 'personalization':
                    this.personalizationView.triggerMethod('uncheck:item', itemId);
                    break;
                default:
                    break;
            }
        },
        addFilterItem: function(itemId, itemType, itemValue, itemData) {
            var item = this.filterItemsCollection.findWhere({
                id: itemId,
                type: itemType
            });
            switch (itemType) {
                case 'caption':
                    if (item) {
                        item.set({
                            value: itemValue,
                            data: itemData
                        }, {
                            silent: true
                        });
                    } else {
                        this.filterItemsCollection.add({
                            id: itemId,
                            type: itemType,
                            value: itemValue,
                            data: itemData
                        }, {
                            silent: true
                        });
                    }
                    this.updateResultsBarView();
                    break;
                case 'location':
                    if (item) {
                        item.set({
                            value: itemValue,
                            data: itemData
                        });
                    } else {
                        this.filterItemsCollection.add({
                            id: itemId,
                            type: itemType,
                            value: itemValue,
                            data: itemData
                        });
                    }
                    this.updateResultsBarView();
                    break;
                case 'category':
                    if (this.widgetOptions.categoriesSelectOne) {
                        var categoryItem = this.filterItemsCollection.findWhere({
                            type: itemType
                        });
                        if (categoryItem) {
                            if (categoryItem === item) {
                                this.filterItemsCollection.remove(item, {
                                    silent: true
                                });
                            } else {
                                categoryItem.set({
                                    id: itemId,
                                    type: itemType,
                                    value: itemValue,
                                    data: itemData
                                }, {
                                    silent: true
                                });
                            }
                            break;
                        }
                    }
                case 'season':
                case 'personalization':
                    if (item) {
                        this.filterItemsCollection.remove(item, {
                            silent: true
                        });
                        break;
                    }
                default:
                    this.filterItemsCollection.add({
                        id: itemId,
                        type: itemType,
                        value: itemValue,
                        data: itemData
                    }, {
                        silent: true
                    });
            }
            if (itemType === 'category') {
                this.checkCategoryFilter();
            }
        },
        removeFilterItems: function(itemType) {
            var _this = this;
            var items;
            if (_.isFalsy(itemType)) {
                this.filterItemsCollection.reset(undefined, {
                    silent: true
                });
            } else {
                items = _.reject(this.filterItemsCollection.models, function(model) {
                    return model.get('type') === itemType;
                }, this);
            }
            if (itemType === 'location') {
                this.filterItemsCollection.reset(items, {
                    silent: false
                });
                this.updateResultsBarView();
            } else if (itemType === 'caption') {
                this.filterItemsCollection.reset(items, {
                    silent: true
                });
                this.updateResultsBarView();
            } else {
                this.filterItemsCollection.reset(items, {
                    silent: true
                });
            }
            if (itemType === 'category') {
                this.checkCategoryFilter();
            }
        },
        filterByLocation: function() {
            var locationModel = this.filterItemsCollection.findWhere({
                type: 'location'
            });
            if (locationModel) {
                this.photos.resetToOriginal();
                if (this.navbarModel.get('location_active')) {
                    var viewPort = this.navbarModel.get('map_viewport');
                    var resetOriginal = false;
                    this.photos.filterPhotosWithLocation(resetOriginal, viewPort);
                }
            }
        },
        checkLocationFilter: function() {
            var locationModel = this.filterItemsCollection.findWhere({
                type: 'location'
            });
            if (locationModel) {
                var viewPort = this.navbarModel.get('map_viewport');
                var resetOriginal = true;
                this.photos.filterPhotosWithLocation(resetOriginal, viewPort);
            }
        },
        resetMapView: function() {
            this.mapView.triggerMethod('reset:map:view');
        },
        renderMapMarkers: function() {
            var locationModel = this.filterItemsCollection.findWhere({
                type: 'location'
            });
            var renderInitialMarkers = !locationModel ? true : false;
            this.mapView.triggerMethod('render:markers', renderInitialMarkers);
        },
        checkCategoryFilter: function() {
            var categoriesSelected = this.filterItemsCollection.findWhere({
                type: 'category'
            });
            this.setCategoryTriggers('filter:collection:change', categoriesSelected);
        },
        buildFilterQuery: function(options) {
            var _this = this;
            var query = '';
            var sortOrder = this.navbarModel.get('sort_by');
            var captionModel = this.filterItemsCollection.findWhere({
                type: 'caption'
            });
            var locationModel = this.filterItemsCollection.findWhere({
                type: 'location'
            });

            var categoriesFiltersModels = [];
            var categoriesModels;
            _.each(this.filterNames, function(filterName) {
                categoriesModels = _.invoke(_this.filterItemsCollection.filter(function(item) {
                    return item.get('data') === filterName && item.get('type') === 'category';
                }), 'get', 'id');
                if (categoriesModels.length > 0) {
                    categoriesFiltersModels.push('[' + categoriesModels.toString() + ']');
                }
            });


            var personalizationModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                return item.get('type') === 'personalization';
            }), 'get', 'id');
            var seasonModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                return item.get('type') === 'season';
            }), 'get', 'id');
            // Start with filters
            query += '&filters={';
            // Check if searching by caption
            if (captionModel) {
                switch (captionModel.get('data')) {
                    case 'caption':
                        query += '"filter_by_caption":{"contains":["' + captionModel.get('value') + '"],"not_contains":[]},';
                        break;
                    case 'userhandle':
                        query += '"filter_by_userhandle":{"equals":"' + captionModel.get('value') + '","not_equals":[],"contains":[],"not_contains":[]},';
                        break;
                    case 'hashtag':
                        query += '"filter_by_hashtag":{"equals":"' + captionModel.get('value') + '","not_equals":[]},';
                        break;
                    default:
                        break;
                }
            }
            // Check for category filters
            // and_categories
            // [[a,b], [c,d], [e]]
            query += !_.isFalsy(categoriesFiltersModels) ? '"and_categories":[' + categoriesFiltersModels.toString() + '],' : '';

            // query += !_.isFalsy(categoriesModels) ? '"in_categories":[' + categoriesModels.toString() + ']' : '';
            // Check for season filters
            query += !_.isFalsy(seasonModels) ? '"months":[' + seasonModels.toString() + '],' : '';
            // Check for personalization filters
            query += !_.isFalsy(personalizationModels) ? '"social_filters": {' : '';
            _.each(personalizationModels, function(item, i, list) {
                var platform = this.navbarModel.get('personalization_platform');
                var social_id = this.navbarModel.get('personalization_social_id');
                var access_token = this.navbarModel.get('personalization_access_token');
                var access_token_secret = this.navbarModel.get('personalization_access_token_secret');
                var longitude = this.navbarModel.get('personalization_longitude');
                var latitude = this.navbarModel.get('personalization_latitude');
                if (item === 'my_photos') {
                    query += '"my_photos":{"platform":"' + platform + '", "social_id":"' + social_id + '"}';
                } else if (item === 'near_me') {
                    query += '"near_me":{"longitude":"' + longitude + '", "latitude":"' + latitude + '"}';
                } else if (item === 'friends_photos') {
                    query += '"friends_photos":{"platform":"' + platform + '", "social_id":"' + social_id + '", "access_token":"' + access_token + '", "access_token_secret":"' + access_token_secret + '"}';
                }
                query += (i < list.length - 1) ? ', ' : '},';
            }, this);
            // Check for location filter
            query += !_.isFalsy(locationModel) ? '"view_port":[' + locationModel.get('data').toString() + '],' : '';
            // Close filters first removing trailing comma if needed
            query = query.replace(/(,$)/g, '');
            query += '}';
            // Get sort order
            switch (sortOrder) {
                case 'sort_recency':
                    query += '&sort={"recency":true,"desc":true}';
                    break;
                case 'sort_popularity':
                    query += '&sort={"popularity":true,"desc":true}';
                    break;
                case 'sort_price_high_low':
                    query += '&sort={"price":true,"desc":true}';
                    break;
                case 'sort_price_low_high':
                    query += '&sort={"price":true,"asc":true}';
                    break;
                default:
                    break;
            }
            this.navbarLayout.triggerMethod('update:filter:query', query);
            if (_.isFalsy(locationModel)) {
                this.analyticsTrack('Apply Interactive Bar', query);
            }
        },
        analyticsTrack: function(ev, filterType, data) {
            var type;
            if (ev === 'Apply Interactive Bar') {
                var captionModel = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'caption';
                }), 'get', 'value');
                var categoriesModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'category';
                }), 'get', 'id');
                var seasonModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'season';
                }), 'get', 'value');
                type = {
                    search: captionModel || false,
                    categoryFilter: categoriesModels || false,
                    personalizationFilter: {
                        myPhotos: false,
                        myFriendPhoto: false,
                        nearMe: false
                    },
                    monthFilter: seasonModels || false,
                    locationFilter: false,
                    sort: this.navbarModel.get('sort_by')
                };
                var personalizationModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'personalization';
                }), 'get', 'id');
                _.each(personalizationModels, function(item, i, list) {
                    switch (item) {
                        case 'my_photos':
                            type.personalizationFilter.myPhotos = true;
                            break;
                        case 'near_me':
                            type.personalizationFilter.nearMe = true;
                            break;
                        case 'friends_photos':
                            type.personalizationFilter.myFriendsPhotos = true;
                            break;
                        default:
                            break;
                    }
                });
                if (filterType === 'location' && !_.isFalsy(data)) {
                    type.locationFilter = data;
                    data = '';
                }
            } else {
                type = filterType;
            }
            var keenData = {
                category: 'interactiveWidget',
                filterType: {
                    type: type
                },
                widgetInfo: {
                    interactiveWidgetOptions: {
                        categories: gon.display_options.interactiveWidgetOptions.categories,
                        location: gon.display_options.interactiveWidgetOptions.location,
                        personalized: gon.display_options.interactiveWidgetOptions.personalized,
                        months: gon.display_options.interactiveWidgetOptions.seasons,
                        search: gon.display_options.interactiveWidgetOptions.search,
                        sort: gon.display_options.interactiveWidgetOptions.sort,
                        sortPopular: gon.display_options.interactiveWidgetOptions.sortPopular,
                        sortPrice: gon.display_options.interactiveWidgetOptions.sortPrice,
                        sortRecent: gon.display_options.interactiveWidgetOptions.sortRecent,
                        widgetType: gon.display_options.interactiveWidgetOptions.widgetType,
                        interactiveWidgetType: gon.display_options.interactiveWidgetOptions.interactiveWidgetType,
                        numOfCategories: gon.display_options.interactiveWidgetOptions.categoryFilters.length,
                        selectedCategories: gon.display_options.interactiveWidgetOptions.selectedCategories
                    },
                    currentAlbum: {
                        id: gon.current_album.id
                    }
                },
                brandInfo: {
                    currentAccount: gon.current_account.id,
                    businessName: gon.current_account.business_name,
                    accountType: gon.current_account.account_type
                }
            };
            App.execute('interactive:widget:analytics', ev, keenData, data);
        }
    });

    App.reqres.setHandlers({
        'get:navbar:mobile:view': function(options, collection) {
            var interactiveWidgetOptions = {};
            var getCategoryAlbums = function(categories, name) {
                $.ajax({
                    url: Routes.category_list_path(accountId),
                    type: 'GET',
                    dataType: 'json',
                    data: {
                        'selected': categories
                    },
                    async: false,
                    success: function(albums) {
                        if (_.isFalsy(albums)) {
                            interactiveWidgetOptions.categories = false;
                        } else {
                            interactiveWidgetOptions.categoryFilters.push({
                                name: name,
                                categories: albums
                            });
                        }
                    }
                });
            };
            if (!_.isFalsy(options) && !_.isFalsy(options.display_options) && !_.isFalsy(options.display_options.interactiveWidgetOptions)) {
                interactiveWidgetOptions = options.display_options.interactiveWidgetOptions;
                if (interactiveWidgetOptions.categories === true) {
                    if (!_.isFalsy(options.current_account) && !_.isFalsy(options.current_account.id)) {
                        var accountId = options.current_account.id;
                        interactiveWidgetOptions.categoryFilters = [];

                        if (interactiveWidgetOptions.selectedCategories.length > 0) {
                            _.each(interactiveWidgetOptions.selectedCategories, function(filter) {
                                getCategoryAlbums(filter.categories, filter.name);
                            });
                        } else {
                            getCategoryAlbums();
                        }
                    } else {
                        interactiveWidgetOptions.categories = false;
                    }
                }
            } else {
                interactiveWidgetOptions = {
                    categories: false
                };
            }
            if (_.isFalsy(interactiveWidgetOptions.categories)) {
                interactiveWidgetOptions.categoryFilters = [];
            }
            interactiveWidgetOptions.current_album = options.current_album;
            interactiveWidgetOptions.current_account = options.current_account;
            interactiveWidgetOptions.interactiveWidgetType = interactiveWidgetOptions.widgetType;
            interactiveWidgetOptions.widgetType = options.type;
            var navbarController = new NavbarMobile.Controller({
                photosCollection: collection,
                widgetOptions: interactiveWidgetOptions
            });
            navbarController._setMainView(navbarController.navbarLayout);
            return navbarController.navbarLayout;
        }

    });
});